
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#d7141a","d":"M0 0h900v600H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 0h900v300H0z"}}),_c('path',{attrs:{"d":"M450 300L0 0v600z","fill":"#11457e"}})])
          )
        }
      }
    